export const MediaType = {
  hls: 'hls',
  video_hd: 'video_hd',
  video_sd: 'video_sd',
  audio: 'audio',
  music: 'music',
};
